/*
 * Hook into Google's Address AutoCompletion service.
 * 
 * Enable this functionality by
 * 1) Including this JS file in your TDF page:
 * 		<pageElement type="script" id="AddressFinderScript" contentType="text/javascript" src="javascript/lancer/addressfinder/AddressFinder.js" />
 * 	
 * 2) Add SP. text field(s) to your page that will host Address Finding functionality
 *   2A) You probably want to assign the field to have an id attribute with the prefix "SP." to avoid APSDK field processing on the field on Continue.
 *   2B) The field MUST have a styleClass of "AddressFinder" for this logic to identify it
 *   2C) Note that the uniqueId on this field will be utilized as part of a key for associating the address parts to other fields, so format appropriately.
 *       e.g. In step (3) below, uniqueId of "MailingAddressFinder" will yield "MailingAddressFinder-Addr1", "MailingAddressFinder-City, etc...
 *       
 * 		<fieldElement type="text" uniqueId="MailingAddressFinder" label="Address lookup..." id="SP.restTavernMailingAddressLookup" size="40" styleClass="AddressFinder">
 *			<fieldHelper type="balloon">Simply start typing your address here and we will see if we can help you find it.</fieldHelper>
 *		</fieldElement>
 *
 * 3) Add text/select list fields to associate the "found" address information for the Addr1, City, State, and ZipCode data.
 *   3A) The Addr1 field MUST include a styleClass of "?-Addr1" where * is the uniqueID of the fieldElement from step (2)  e.g. "MailingAddressFinder-Addr1"
 *   3B) The City field MUST include a styleClass of "?-City" where * is the uniqueID of the fieldElement from step (2)  e.g. "MailingAddressFinder-City"
 *   3C) The State field MUST include a styleClass of "?-State" where * is the uniqueID of the fieldElement from step (2)  e.g. "MailingAddressFinder-State"
 *   3D) The ZipCode field MUST include a styleClass of "?-ZipCode" where * is the uniqueID of the fieldElement from step (2)  e.g. "MailingAddressFinder-ZipCode"
 *
 * 4) Include the Google library javascript in site_shell.jsp (or alternatively in your page's TDF).
 * 		<script type="text/javascript" src="https://maps.google.com/maps/api/js?sensor=true&libraries=places"></script>
 * 
 * 5) Optionally, add styling for the AddressFinder field in your .CSS file
 * 		fieldset.standardForm .formRow.AddressFinder {line-height: 22px; background: #d0dff7 url('address-lookup.png') repeat-x 0 0; border: 1px solid #c0ccdf; padding: 10px 0; border-radius: 5px; margin-bottom: 10px;}
 * 		fieldset.standardForm .formRow.AddressFinder label#autocomplete_label {font-weight: bold;}
 */

// Setup the namespace for this logic
var addressFinder = addressFinder || {};


addressFinder.initialize = function() {
	ap.consoleInfo("AddressFinder initialize!");
	try {
		var addressFinderFields = $("div.AddressFinder input");
		for (var index = 0; index < addressFinderFields.length; index++) {
			var addressFinderElement = addressFinderFields[index];
			var addressFinderId = addressFinderElement.id;
			ap.consoleInfo("AddressFinder field found! :: " + addressFinderId);

			var assocElementAddr1 = $("div."+addressFinderId+"-Addr1 label")[0];
			var assocElementCity = $("div."+addressFinderId+"-City label")[0];
			var assocElementState = $("div."+addressFinderId+"-State label")[0];
			var assocElementZipCode = $("div."+addressFinderId+"-ZipCode label")[0];
			
			if (assocElementAddr1 == undefined) {
				ap.consoleInfo("Failed to find Addr1 field association for AddressFinder field :: " + addressFinderId);
			} if (assocElementCity == undefined) {
				ap.consoleInfo("Failed to find City field association for AddressFinder field :: " + addressFinderId);
			} if (assocElementState == undefined) {
				ap.consoleInfo("Failed to find State field association for AddressFinder field :: " + addressFinderId);
			} if (assocElementZipCode == undefined) {
				ap.consoleInfo("Failed to find ZipCode field association for AddressFinder field :: " + addressFinderId);
			} else {
				// Feed the Finder with addr1, city, state, zip (uniqueId), then associate it to the
				//   the field that will AJAX to Google Places (the "Enter Address Here:" Field)
				var finder = new addressFinder.Finder(assocElementAddr1.htmlFor,
						assocElementCity.htmlFor, assocElementState.htmlFor, assocElementZipCode.htmlFor);
				finder.initialize(addressFinderElement);
			}
		}
	}
	catch(e){
		ap.consoleInfo("AddressFinder initialize() caught exception! :: " + e);
	}
};


/*
 * For some older browsers (IE9 specifically), the MailingAddressLookup field was being submitted with the help text "Enter a location"
 * This caused the page to report that there were changes on Continue, when in fact there were none.  This function clears the
 * help text value if it's still there in order to avoid this situation.
 */
addressFinder.submit = function() {
	ap.consoleInfo("AddressFinder submit!");
	var maLookupField = page.getField("MailingAddressLookup");
	if (maLookupField !== null) {
		maLookupField.setValue("");
	}
	return true;
};


addressFinder.Finder = function(addr1, city, state, zip) {
	
	this.autocomplete = null;

	//These are Google Types from Places Object
	var component_form = {
		'street_number': 'short_name',
		'route': ['long_name', 'short_name'],
		'locality': 'long_name',
		'administrative_area_level_1': 'short_name',
		'country': 'long_name',
		'postal_code': 'short_name',
		'sublocality': 'long_name',
		'neighborhood': 'long_name'
	};

	var form_ids = {
		'administrative_area_level_1': state,
		'postal_code': zip
	};
	
	this.initialize = function(element) {
		autocomplete = new google.maps.places.Autocomplete(element, { types: [ 'geocode' ] });

		google.maps.event.addListener(autocomplete, 'place_changed', function() {
			var place = autocomplete.getPlace();
			var streetnumber = '';
			var streetshort = '';
			var streetname = '';
			var locality = '';
			var sublocality = '';
			var neighborhood = '';

			for (var j = 0; j < place.address_components.length; j++) {
				// Address components can/do have multiple types; see if it contains a type we care about
				var att = '';
				for (var i=0; i<place.address_components[j].types.length; i++) {
					var componentType = place.address_components[j].types[i];
					if (component_form[componentType]) {
						att = componentType;
					}
				}
				if (component_form[att]) {
					var val = "";
					var val2 = "";
					if (typeof(component_form[att]) != 'object'){
						val = place.address_components[j][component_form[att]];
					}
					else{
						val = place.address_components[j][component_form[att][0]];
						val2 = place.address_components[j][component_form[att][1]];
					}
					if(att == 'street_number') {
						streetnumber = val;	
					}
					else if(att == 'route') {
						streetname = val;
						streetshort = val2;
					}
					else if(att == 'locality') {
						locality = val;
					}
					else if(att == 'sublocality') {
						sublocality = val;
					}
					else if(att == 'neighborhood') {
						neighborhood = val;
					}
					else {
					    var field = page.getField(form_ids[att]);
					    if (field != null)
					    	field.setValue(val);
					}
				}
			}
		    var field = page.getField(addr1);
		    if (field != null)
		    	field.setValue(streetnumber + ' ' + streetname);
		    // Finding the hidden fields for comparison to Autocomplete
		    field = page.getField("ApplicantAddressAddr1Short");
		    if (field != null)
		    	field.setValue(streetnumber + ' ' + streetshort);
		    else {
		    	field = page.getField("LocationAddressAddr1Short");
		    	if (field != null)
			    	field.setValue(streetnumber + ' ' + streetshort);
		    }
		    field = page.getField("ApplicantAddressAddr1Long");
		    if (field != null)
		    	field.setValue(streetnumber + ' ' + streetname);
		    else {
		    	field = page.getField("LocationAddressAddr1Long");
		    	if (field != null)
			    	field.setValue(streetnumber + ' ' + streetname);
		    }
		    
		    
		    
		    // check city value for 'New York' and substitute borough name in that case
		    var cityField = page.getField(city);
		    if (cityField != null) {
		    	if ((locality=='New York'||locality=='') && sublocality!='') {
		    		if (sublocality=='Queens' && neighborhood!='') {
			    		cityField.setValue(neighborhood);
		    		} else {
			    		cityField.setValue(sublocality);
		    		}
		    	} else {
		    		cityField.setValue(locality);
		    	}
		    }
		});
		
	};


	this.geolocate = function() {
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition( function(position) {
				var geolocation = new google.maps.LatLng(position.coords.latitude,position.coords.longitude);
				autocomplete.setBounds(new google.maps.LatLngBounds(geolocation, geolocation));
			});
		}
	};	
	
};